import UI from './ui-base';
import { toHTML, dataSetToObject } from '../util/dom-util';
import EventHandler from '../_dependencyvendor/event-handler';

// eslint-disable-next-line no-unused-vars
const VERSION = '0.0.1';
const NAME = 'ui.rsliders';

// data-attribute 로 설정 가능한 옵션 들
const dataAttrConfig = {
  blockStep: 0,
};

const defaultConfig = {
  ...dataAttrConfig,
};

class RangeSliderMulti extends UI {
  constructor(element, config = {}) {
    super(element, config);
    this._setupConfog(config);
    this._fake = null;
    this._minInput = null;
    this._maxInput = null;
    this._minHandle = null;
    this._maxHandle = null;
    this._fill = null;
    this._currentValues = [-1, -1];
    this._init();
  }

  static get EVENT() {
    return {
      CHANGE: `${NAME}.change`,
    };
  }

  static get NAME() {
    return NAME;
  }

  /**
   * 삭제
   */
  destroy() {
    this._removeEvents();
    this._removeVars();
    super.destroy();
  }

  _setupConfog(config) {
    this._config = {
      ...defaultConfig,
      ...config,
      ...dataSetToObject(this._element, dataAttrConfig, 'rsliders'),
    };
  }

  /**
   * 필요에 따라 public으로..
   */
  _init() {
    this._createElements();
    this._initVars();
    this._initEvents();

    this._currentValues[0] = this._minInput.value;
    this._currentValues[1] = this._maxInput.value;
    this._render();
  }

  /**
   * 변수 초기화
   */
  _initVars() {
    const inputs = this._element.querySelectorAll('input[type="range"]');
    this._minInput = inputs[0];
    this._maxInput = inputs[1];
    this._minHandle = this._element.querySelector('.range-fake__handle.min');
    this._maxHandle = this._element.querySelector('.range-fake__handle.max');
    this._fill = this._element.querySelector('.range-fake__fill');
  }

  /**
   * 이벤트 초기화
   */
  _initEvents() {
    // min handler
    EventHandler.on(this._minInput, super._eventName('input'), e => {
      e.target.value = Math.min(
        parseInt(e.target.value),
        parseInt(this._maxInput.value) - parseInt(this._config.blockStep),
      );
      this._currentValues[0] = e.target.value;
      EventHandler.trigger(this._element, RangeSliderMulti.EVENT.CHANGE, {
        value: this._currentValues,
      });
      this._render();
    });

    // max handler
    EventHandler.on(this._maxInput, super._eventName('input'), e => {
      e.target.value = Math.max(
        parseInt(e.target.value),
        parseInt(this._minInput.value) + parseInt(this._config.blockStep),
      );
      this._currentValues[1] = e.target.value;
      EventHandler.trigger(this._element, RangeSliderMulti.EVENT.CHANGE, {
        value: this._currentValues,
      });
      this._render();
    });
  }

  /**
   * 변수 초기화
   */
  _removetVars() {
    this._element.removeChild(this._fake);
    this._fake = null;
    this._minInput = null;
    this._maxInput = null;
    this._minHandle = null;
    this._maxHandle = null;
    this._fill = null;
    this._currentValues = [-1, -1];
    this._config = null;
    this._element = null;
  }

  /**
   * 이벤트 초기화
   */
  _removeEvents() {
    EventHandler.off(this._inputs[0], super._eventName('input'));
    EventHandler.off(this._inputs[1], super._eventName('input'));
  }

  _render() {
    this._minHandle.style.left = `${this._currentValues[0]}%`;
    this._maxHandle.style.left = `${this._currentValues[1]}%`;
    Object.assign(this._fill.style, {
      left: `${this._currentValues[0]}%`,
      right: `${100 - this._currentValues[1]}%`,
    });
  }

  _createElements() {
    const template = `
      <div class="range-fake">
        <span class="range-fake__bg"></span>
        <span class="range-fake__fill" style="width:auto;"></span>
        <button type="button" class="range-fake__handle min"></button>
        <button type="button" class="range-fake__handle max"></button>
      </div>
    `;

    this._fake = toHTML(template);
    this._element.appendChild(this._fake);
  }
}

export default RangeSliderMulti;
